import { z } from "zod";

import { siteDocumentDtoSchema } from "./site-document-dto";

export enum ESiteDocumentWithPhotoSource {
  DOCUMENT = "DOCUMENT",
  PHOTO = "PHOTO",
}

export const siteDocumentWithPhotoDtoSchema = siteDocumentDtoSchema.extend({
  source: z.nativeEnum(ESiteDocumentWithPhotoSource),
});

export type TSiteDocumentWithPhotoDto = z.infer<typeof siteDocumentWithPhotoDtoSchema>;

export const siteDocumentsWithPhotosDtoSchema = z.object({
  documents: z.array(siteDocumentWithPhotoDtoSchema),
});

export type TSiteDocumentsWithPhotosResponseDto = z.infer<typeof siteDocumentsWithPhotosDtoSchema>;
